/**
 * @generated SignedSource<<a6596ffd136887faae9ed6070d67297a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApprovalStyle = "AUTOMATIC" | "MANUAL" | "%future added value";
export type CapabilityType = "BUILDKITE_PIPELINE" | "GITHUB_ACTIONS_WORKFLOW" | "%future added value";
export type CreateCapabilityInput = {
  approvalStyle: ApprovalStyle;
  capabilityType: CapabilityType;
  description: string;
  integrationId?: any | null | undefined;
  isActive?: boolean;
  name: string;
  parametersSchema?: any | null | undefined;
  targetConfig: any;
};
export type NewCapabilityWizardCreateMutation$variables = {
  input: CreateCapabilityInput;
};
export type NewCapabilityWizardCreateMutation$data = {
  readonly createCapability: {
    readonly capability: {
      readonly id: any;
      readonly name: string;
    } | null | undefined;
    readonly error: string | null | undefined;
  };
};
export type NewCapabilityWizardCreateMutation = {
  response: NewCapabilityWizardCreateMutation$data;
  variables: NewCapabilityWizardCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCapabilityPayload",
    "kind": "LinkedField",
    "name": "createCapability",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCapability",
        "kind": "LinkedField",
        "name": "capability",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NewCapabilityWizardCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NewCapabilityWizardCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4cd6d1ea09f7f5666ee5e1694408ebb8",
    "id": null,
    "metadata": {},
    "name": "NewCapabilityWizardCreateMutation",
    "operationKind": "mutation",
    "text": "mutation NewCapabilityWizardCreateMutation(\n  $input: CreateCapabilityInput!\n) {\n  createCapability(input: $input) {\n    capability {\n      id\n      name\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "5580d8c03dae1fa51e677c56ff542ba8";

export default node;
